import {InfoValues, InvoiceLine, PageValues, TaxesAndTotal} from 'types/invoices';

export const documnetPageValues: PageValues = {
    periodFrom: '',
    periodTo: '',
    taxPointDate: '',
    buyerReference: '',
    contractDocumentReference: '',
    purchaseOrderReference: '',
    salesOrderReference: '',
};
export const generalInfoPageValues: InfoValues = {
    bic: '',
    companyNameAndTIN: '',
    companyTIN: '',
    customerAddress: '',
    customerCompanyNameOrTIN: undefined,
    customerEmail: '',
    customerPhoneNumber: '',
    dueDate: '',
    iban: '',
    irn: '',
    issueDate: '',
    // issueTime: '',
    storageLocationAddress: '',
    storageLocationName: '',
    supplierStreetName: '',
    supplierCityName: '',
    supplierPostalZone: '',
    supplierCountry: '',
    supplierEmail: '',
    supplierPhoneNumber: '',
    customerCity: '',
    customerZip: '',
    customerCountry: '',
    customerStreet: '',
};
export const taxesPageValue: TaxesAndTotal = {
    calculationsByTaxCategory: [],
    // id: '',
    // percent: '',
    taxTotal: '',
    // chargesRadio: 'true',
    // charges: [],
    // whtAppliedRadio_2: 'true',
    baseAmount: '',
    multiplierFactorNumeric: '',
    whtChargeAmount_1: '3',
    lineExtensionAmount: '',
    taxExclusiveAmount: '',
    taxExclusiveAmountDisplay: '',
    taxInclusiveAmount: '',
    taxInclusiveAmountDisplay: '',
    // whtChargeAmount_2: '',
    prepaidAmount: '0',
    payableRoundingAmount: '0',
    payableAmount: '',
    // paymentDueDate: '',
    allowanceTotalAmount: '0',
    allowanceTotalAmountDisplay: '0',
    chargeTotalAmount: '0',
    chargeTotalAmountDisplay: '0',
    withholdingTax: '',
};

export const DEFAULT_LINE_VALUES: Partial<InvoiceLine> = {
    description: '',
    code: '',
    gtin: '',
    qty: '',
    isHsn: 'HS',
    serviceCategory: {label: '', value: ''},
    isMarkedItem: false,
    copyActions: {
        allowToCopy: false,
        allowToDuplicateDown: false,
        allowToPaste: false,
    },
};
